import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "./ducks/auth.duck";
import * as resetPassword from "./resetPassword";
import { metronic } from "../../_metronic";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  i18n: metronic.i18n.reducer,
  builder: metronic.builder.reducer,
  resetPassword: resetPassword.resetPasswordReducer
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
